import { api } from "@/frontend/services/api";
import type {
  CreateRoleRequestDTO,
  UpdateRoleRequestDTO,
  UpdateRolePermissionsRequestDTO,
  UpdateRolePermissionsResponseDTO,
  RoleResponseDTO,
  RolesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/roles/private";

export const roleService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<RolesPaginatedResponseDTO>>(
      BASE_URL,
      params
    );
  },
  // Mantener getAll por compatibilidad (deprecated)
  getAll: () =>
    api.get<ApiResponse<RolesPaginatedResponseDTO>>(BASE_URL),
  getById: (id?: string) =>
    api.get<ApiResponse<RoleResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateRoleRequestDTO) =>
    api.post<ApiResponse<RoleResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateRoleRequestDTO) =>
    api.put<ApiResponse<RoleResponseDTO>>(`${BASE_URL}/${id}`, data),
  updatePermissions: (id: string, data: UpdateRolePermissionsRequestDTO) =>
    api.put<ApiResponse<UpdateRolePermissionsResponseDTO>>(`${BASE_URL}/${id}/permissions`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
